import { IsSchemaCompliant } from 'app/common/interfaces/isSchemaCompliant';

// ChildFieldsDynamic models data returned from the API.
// *** Shape should match exactly what the API returns. ***
export class ChildFieldsDynamic implements IsSchemaCompliant {
    public httpVerb: string;
    public api: string;

    // Not part of data returned from API.
    public initialLoadComplete: boolean = false;
    public isReloading: boolean = false;
    public userChangedOwningField: boolean = false; // Most control types will likely not use this. TextBox control will set this to true if they press a key in the TextBox.

    // Constructor that creates a new object from JSON data (loose untyped JSON returned from a web api).
    constructor(jsonData: any) {
        this.httpVerb = jsonData.httpVerb;
        this.api = jsonData.api;
    }

    // User defined type guard to verify data is a valid ChildFieldsDynamic.
    public isSchemaCompliant(): boolean {
        let isCompliant: boolean = true;

        // Make sure all non-nullable properties are present.
        isCompliant = !!this.httpVerb && !!this.api;
        if (!isCompliant) {
            console.error('JSON is non-compliant - childFieldsDynamic required properties not found.');
        }

        return isCompliant;
    }
}
